import { Component } from '@angular/core';
import { ShareDataService } from '@signature-it/ngx-generic/services';

@Component({
    selector: 'user-login-button',
    templateUrl: './login-button.html',
    styleUrls: ['./login-button.scss'],
    standalone: false
})
export class UserLoginButtonComponentGeneric {
    constructor(
        public sharedSvc: ShareDataService
    ) {}
}
